<template>
  <div class="riiqosxn riiqosxn-three">
    <v-container>
      <v-row>
        <v-col cols="12" md="6" class="col-left"></v-col>
        <v-col cols="12" md="6">
          <div class="col-content">
            <h1 class="title-lg">Beautiful Data</h1>
            <h5>THE BEST VISUALS</h5>
            <p>Tons of data in real time and in one place. Everything from your website, to customers, chat, and more. Beautiful and easy to read charts that help you act smarter and faster, and run your business more efficiently.</p>
            <router-link to="contact" class="btn btn-getstarted">Get Started</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div class="img-1">
      <!-- <div class="img-2"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'SxnThree',

  data: () => ({
    
  }),
};
</script>
